<template>
    <div class="container d-flex justify-content-center align-items-center horizontal-scrollable flex-column">

        <h4 class="display-6 text-center mb-4 mt-4">
            Mora de Créditos
            <br>
            {{ etiqueta || 'Créditos en Mora' }} días
        </h4>

        <table class="table table-striped table-hover" id="myTable">
            <thead>
                <tr>
                    <th>Index</th>
                    <th>Beneficiario</th>
                    <th class="text-center">DNI</th>
                    <th>Saldo Capital</th>
                    <th>Saldo Interes corriente (A la fecha)</th>
                    <th class="text-center">Saldo Intereres Moratorio(A la fecha)</th>
                    <th>Total Saldo Vencido a pagar(A la fecha)</th>
                    <th>Total Saldo a pagar  para cancelación(A la fecha)</th>
                    <th>Asesor</th>
                </tr>
            </thead>

            <tbody v-if="ready">
                <tr @click="irCredito(credito.cliente.dni)" v-for="(credito, index) in creditos" :key="credito.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ credito.cliente.nombres }}</td>
                    <td>{{ credito.cliente.dni }}</td>
                    <td>{{ formatoNumero(credito.saldo) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.simularPagoHoy?.saldoInteres || 0) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.simularPagoHoy?.saldoMora || 0) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.simularPagoHoy.capitalDebePagar + (credito.simularPagoHoy?.saldoInteres || 0) +
                        (credito.simularPagoHoy?.saldoMora || 0)) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(credito.saldo + (credito.simularPagoHoy?.saldoInteres || 0) +
                        (credito.simularPagoHoy?.saldoMora || 0)) }} {{ moneda }}</td>
                    <td> {{credito.nombreAsesor}} </td>
                </tr>
            </tbody>

            <tbody v-else>
                <tr>
                    <td colspan="10" class="text-center">
                        <div class="spinner-border text-warning text-center" role="status">
                            <span class="visually-hidden text-center">Loading...</span>
                        </div>
                    </td>
                </tr>
            </tbody>

            <tfoot v-if="ready">
                <tr class="table-dark">
                    <td colspan="3" class="text-end"><strong>Totales:</strong></td>
                    <td>{{ formatoNumero(totalCapital) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(totalInteres) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(totalMora) }} {{ moneda }}</td>
                    <td>{{ formatoNumero(totalAdeudado) }} {{ moneda }}</td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import { store } from '../store'
import DataTables from 'datatables.net'
import Security from '../security'

export default {
    name: 'TablaCreditosMora',

    data() {
        return {
            creditos: [],
            rango: '',
            etiqueta: '',
            ready: false,
            moneda: 'Lps'
        }
    },

    created() {
        // this.creditos = store.creditos


        // this.ready = true
    },
    beforeMount(){

       

    },

    mounted() {


            store.etiqueta = this.$route.query.etiqueta || ''
            store.rango = this.$route.query.rango || ''
            store.sucursalSeleccionada = this.$route.query.sucursal || ''
            store.asesorSeleccionado = this.$route.query.asesor
                ? parseInt(this.$route.query.asesor, 10)
                : null
            store.tipoCarteraSeleccionado = (this.$route.query.tipoCartera || 0  )
            store.tipoCarterasSeleccionadas = this.$route.query.tipoCarteras
                ? this.$route.query.tipoCarteras.split(',').map(tipo => parseInt(tipo, 10)).filter(tipo => !Number.isNaN(tipo))
                : []
            store.estadoSeleccionado = this.$route.query.estado || ''

            console.log('Parámetros de consulta:', {
                etiqueta: store.etiqueta,
                rango: store.rango,
                sucursal: store.sucursalSeleccionada,
                asesor: store.asesorSeleccionado,
                tipoCartera: store.tipoCarteraSeleccionado,
                estado: store.estadoSeleccionado
            })

           fetch(process.env.VUE_APP_API_URL + "/admin/credito/credito-mora", Security.requestOptions({ 
            sucursal: store.sucursalSeleccionada, 
            asesor: store.asesorSeleccionado, 
            tipoCartera: parseInt(store.tipoCarteraSeleccionado), 
            tipoCarteras: store.tipoCarterasSeleccionadas,
            estado: store.estadoSeleccionado, 
            rango: store.rango }))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);

            console.error(response.message)
          } else {

            console.log(response.data);
            this.creditos = response.data.creditos;

            this.ready = true;
            this.$nextTick(() => {
                        this.initializeDataTable()
                    })
          }
        })
        .catch(error => {
          this.$emit('error', error)
        })


    },

    computed: {
        totalCapital() {
            return this.creditos.reduce((s, c) => s + (c.saldo || 0), 0)
        },
        totalInteres() {
            return this.creditos.reduce((s, c) => s + (c.simularPagoHoy?.saldoInteres || 0), 0)
        },
        totalMora() {
            return this.creditos.reduce((s, c) => s + (c.simularPagoHoy?.saldoMora || 0), 0)
        },
        totalAdeudado() {
            return this.creditos.reduce(
                (s, c) =>
                    s + (c.saldo || 0) + (c.simularPagoHoy?.saldoInteres || 0) + (c.simularPagoHoy?.saldoMora || 0),
                0
            )
        }
    },

    methods: {
        formatoNumero(n) {
            return new Intl.NumberFormat('es-HN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(n)
        },
        initializeDataTable() {
            const myTable = document.querySelector('#myTable')
            if (myTable) {
                new DataTables(myTable)
            }
        },
        irCredito(dni) {
            this.guardarEnLocalStorage('busqueda', dni);
            window.location.href = '/cartera';
        },
        guardarEnLocalStorage(clave, arrayDeObjetos, tamañoMaximo = 5 * 1024 * 1024) { // 5MB por defecto
            // Convertimos el array de objetos a una cadena JSON
            const jsonString = JSON.stringify(arrayDeObjetos);

            // Calculamos el tamaño del JSON en bytes
            const tamañoJSON = new Blob([jsonString]).size;

            // Verificamos si el tamaño es menor al límite permitido
            if (tamañoJSON <= tamañoMaximo) {
                // Si el tamaño es adecuado, lo guardamos en el localStorage
                localStorage.setItem(clave, jsonString);
            } else {
                console.error(`Error: El array excede el tamaño máximo permitido de ${tamañoMaximo} bytes.`);
            }
        },
    }
}
</script>

<style scoped></style>
